import { useEffect, useState } from 'react'

import { updateAddressField } from '@/common/helpers/helpers'

const useEditAddress = ({ shippingAddress, showModal }) => {
  const [address, setAddress] = useState(shippingAddress || {})

  useEffect(() => {
    if (!showModal && shippingAddress) {
      setAddress(shippingAddress)
    }
  }, [shippingAddress, showModal])

  const handleAddressChange = e => {
    const { name, value } = e.target

    if (name === 'tax_id') {
      setAddress({
        ...address,
        customer: {
          ...address.customer_profile,
          tax_id: value,
        },
      })
      return
    }

    setAddress(updateAddressField(address, name, value))
  }

  const getPhoneNumber = () => {
    return `+${address?.phone?.prefix} ${address?.phone?.number}`
  }

  return {
    address,
    handleAddressChange,
    getPhoneNumber,
  }
}

export default useEditAddress
